var React = require('react');

function Sl (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#0000cd","d":"M0 320.3h640V480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 160.7h640v159.6H0z","key":1}),React.createElement("path",{"fill":"#00cd00","d":"M0 0h640v160.7H0z","key":2})]));
}

Sl.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Sl;

Sl.default = Sl;
